export const getPlayerRoleIcon = (
  role: string,
  color = "F1F1F1",
  size: "small" | "large" = "large",
): JSX.Element | null => {
  switch (role) {
    case "tank":
      return (
        <>
          <path
            d="M16.619 14C16.619 15.4465 15.4465 16.619 14 16.619C12.5535 16.619 11.381 15.4465 11.381 14C11.381 12.5535 12.5535 11.381 14 11.381C15.4465 11.381 16.619 12.5535 16.619 14Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25 12.6381V15.3619C25 15.4776 24.9062 15.5714 24.7905 15.5714H22.7665C22.1152 19.2298 19.2298 22.1152 15.5714 22.7665V24.7905C15.5714 24.9062 15.4776 25 15.3619 25H12.6381C12.5224 25 12.4286 24.9062 12.4286 24.7905V22.7665C8.77018 22.1152 5.88483 19.2298 5.23345 15.5714H3.20952C3.09381 15.5714 3 15.4776 3 15.3619V12.6381C3 12.5224 3.09381 12.4286 3.20952 12.4286H5.23345C5.88483 8.77018 8.77018 5.88483 12.4286 5.23345V3.20952C12.4286 3.09381 12.5224 3 12.6381 3H15.3619C15.4776 3 15.5714 3.09381 15.5714 3.20952V5.23345C19.2298 5.88483 22.1152 8.77018 22.7665 12.4286H24.7905C24.9062 12.4286 25 12.5224 25 12.6381ZM14 20.4082C10.4609 20.4082 7.59184 17.5391 7.59184 14C7.59184 10.4609 10.4609 7.59184 14 7.59184C17.5391 7.59184 20.4082 10.4609 20.4082 14C20.4082 17.5391 17.5391 20.4082 14 20.4082Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.619 14C16.619 15.4465 15.4465 16.619 14 16.619C12.5535 16.619 11.381 15.4465 11.381 14C11.381 12.5535 12.5535 11.381 14 11.381C15.4465 11.381 16.619 12.5535 16.619 14Z"
            fill={color}
          />
        </>
      );
    case "st":
      return (
        <>
          <g clipPath="url(#clip0_2280_3969)">
            <path
              d="M3 9.6075L8.17927 15.83L4.33045 20.6275L10.9352 19.7725L12.5032 24L14.2138 19.7725L21.6263 21.2925L16.257 17.5875L25 14.31L17.0173 13.455L21.6263 8.3725L14.2138 12.695V5L10.9352 13.455L3 9.6075Z"
              stroke={color}
              strokeWidth="1.4"
              strokeMiterlimit="16"
            />
          </g>
          <defs>
            <clipPath id="clip0_2280_3969">
              <rect
                width={size === "small" ? "28" : "44"}
                height={size === "small" ? "28" : "44"}
                fill="white"
              />
            </clipPath>
          </defs>
        </>
      );
    case "rat":
      return (
        <>
          <path
            d="M6.71695 6H3L7.29818 14L3.00045 22H6.71741L11.1313 14L6.71695 6Z"
            fill={color}
          />
          <path
            d="M14.1505 6H10.4336L14.7318 14L10.434 22H14.151L18.5649 14L14.1505 6Z"
            fill={color}
          />
          <path
            d="M21.5841 6H17.8672L22.1654 14L17.8676 22H21.5846L25.9985 14L21.5841 6Z"
            fill={color}
          />
        </>
      );
    case "lw":
      return (
        <>
          <path
            d="M4.82278 3.49865C15.2232 10.7982 21.5692 6.82237 22.2903 11.6831C23.0113 16.5438 22.5234 18.4981 23.0234 23.5981L20.9241 20.9935L18.0234 21.6981L18.5368 19.6367C15.2273 21.0332 13.4234 20.4981 11.1234 18.4981C12.421 18.4188 15.4603 17.9776 16.8234 16.1981C13.1536 16.1981 9.32341 15.8987 7.02341 12.3981C10.3234 13.0981 13.1234 13.6138 15.0234 12.3981C9.76366 10.8983 4.82259 9.89821 4.82278 3.49865Z"
            stroke={color}
            strokeWidth="1.4"
            strokeMiterlimit="16"
          />
        </>
      );
    case "cam":
      return (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.9794 12.3385L6.65217 24.7439C12.1369 25.7014 15.2139 25.7267 20.6934 24.9489L20.9908 12.3385L22.9542 14.6517L27 12.602L26.9142 12.4311C25.152 8.92325 24.138 6.90461 21.4966 4.5204L17.3318 3.1149L16.8558 2.5H10.8764L10.46 3.1149L6.08696 4.5204C3.76491 7.39007 2.4799 9.01317 1 12.602L5.254 14.6517L6.9794 12.3385ZM19.241 9.93707V11.5093C19.241 12.1915 19.1675 12.78 19.0206 13.275C18.8737 13.7658 18.6618 14.1693 18.3848 14.4854C18.112 14.7974 17.7868 15.0282 17.4091 15.178C17.0313 15.3277 16.6117 15.4026 16.15 15.4026C15.7807 15.4026 15.4366 15.3568 15.1176 15.2653C14.7986 15.1696 14.5112 15.022 14.2552 14.8223C14.0034 14.6227 13.7851 14.371 13.6005 14.0674C13.42 13.7596 13.2815 13.3936 13.185 12.9693C13.0885 12.545 13.0402 12.0584 13.0402 11.5093V9.93707C13.0402 9.25492 13.1136 8.67052 13.2605 8.18387C13.4116 7.69305 13.6235 7.29167 13.8963 6.97971C14.1733 6.66775 14.5007 6.43898 14.8784 6.2934C15.2561 6.14366 15.6758 6.06879 16.1374 6.06879C16.5067 6.06879 16.8488 6.11663 17.1635 6.21229C17.4825 6.3038 17.77 6.4473 18.026 6.6428C18.282 6.83829 18.5002 7.08993 18.6807 7.39773C18.8612 7.70137 18.9996 8.06532 19.0962 8.48958C19.1927 8.90969 19.241 9.39218 19.241 9.93707ZM17.4216 9.69374V11.7464C17.4216 12.1582 17.3944 12.5076 17.3398 12.7946C17.2853 13.0816 17.2013 13.3145 17.088 13.4934C16.9789 13.6681 16.8446 13.797 16.6851 13.8802C16.5298 13.9592 16.3515 13.9988 16.15 13.9988C15.9863 13.9988 15.8353 13.9738 15.6968 13.9239C15.5625 13.874 15.4429 13.7949 15.3379 13.6868C15.2372 13.5745 15.1491 13.431 15.0735 13.2563C15.0022 13.0774 14.9476 12.8632 14.9099 12.6137C14.8763 12.3641 14.8595 12.075 14.8595 11.7464V9.69374C14.8595 9.28612 14.8868 8.94088 14.9413 8.65804C15.0001 8.37104 15.084 8.14227 15.1931 7.97173C15.3023 7.79704 15.4345 7.67018 15.5897 7.59115C15.7492 7.51212 15.9318 7.4726 16.1374 7.4726C16.3011 7.4726 16.4501 7.49756 16.5844 7.54747C16.7187 7.59738 16.8383 7.67641 16.9432 7.78456C17.0481 7.8927 17.1363 8.03413 17.2076 8.20882C17.279 8.37936 17.3314 8.58733 17.365 8.83274C17.4028 9.07814 17.4216 9.36514 17.4216 9.69374ZM11.6993 15.2778V6.17486H11.5042L7.70816 7.51628V8.93256L9.8863 8.24626V15.2778H11.6993Z"
            fill={color}
          />
        </>
      );
    case "rw":
      return (
        <>
          <path
            d="M23.1772 3.49865C12.7772 10.7982 6.4314 6.82241 5.7104 11.6832C4.98941 16.5439 5.47721 18.4982 4.97722 23.5982L7.07646 20.9935L9.97706 21.6982L9.46368 19.6367C12.7731 21.0332 14.5769 20.4982 16.8768 18.4982C15.5793 18.4188 12.5401 17.9777 11.177 16.1982C14.8467 16.1982 18.6767 15.8987 20.9767 12.3981C17.6768 13.0982 14.8769 13.6138 12.977 12.3982C18.2365 10.8983 23.1774 9.89821 23.1772 3.49865Z"
            stroke={color}
            strokeWidth="1.4"
            strokeMiterlimit="16"
          />
        </>
      );
    case "agile_cdm":
      return (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.5431 4.71153C11.9501 4.58261 10.4322 5.2845 10.3773 5.79468C10.3225 6.30486 12.0832 8.38232 11.6099 8.669C11.1366 8.95568 8.31994 7.79956 7.99917 7.06048C7.67839 6.3214 8.4763 4.27707 6.94364 4.80702C5.41098 5.33698 0.628056 11.3368 2.44829 12.3539C4.26879 13.3712 16.596 19.6968 20.0909 20.9328C23.5859 22.1688 26.1539 20.3476 25.9144 19.5528C25.6769 18.7642 18.0842 12.3024 17.6059 11.5649C17.5973 11.5516 17.5952 11.5398 17.5939 11.524C17.5133 10.5598 17.1557 10.4714 16.5322 10.3279C16.4983 10.3201 16.47 10.2961 16.4563 10.2641C16.052 9.32348 15.7227 8.99436 14.9943 8.57694C14.9755 8.56613 14.9611 8.55215 14.9514 8.53266C14.7833 8.19322 13.1061 4.83393 12.5431 4.71153ZM15.1196 11.0917C15.1334 11.0879 15.1482 11.0912 15.1592 11.1005L16.4628 12.2058C16.4891 12.2281 16.48 12.2708 16.4469 12.2805L9.33595 14.3634C9.32367 14.367 9.31043 14.365 9.29977 14.3579L7.6087 13.2356C7.57769 13.215 7.58529 13.1675 7.62117 13.1576L15.1196 11.0917ZM17.4994 13.0831C17.5142 13.0788 17.5301 13.0827 17.5413 13.0933L18.717 14.2058C18.7414 14.2288 18.7316 14.2695 18.6994 14.279L12.9014 15.9752C12.8895 15.9787 12.8766 15.9769 12.8661 15.9703L11.2751 14.966C11.2434 14.946 11.2502 14.8981 11.2861 14.8877L17.4994 13.0831Z"
            fill={color}
          />
          <path
            d="M18.5346 21.1262L17.7367 21.901L16.5263 21.2667L16.4468 20.1302L18.5346 21.1262Z"
            fill={color}
          />
          <path
            d="M21.9227 22.1159L20.9756 23.3241L19.6759 22.6959L19.5906 21.4753L21.9227 22.1159Z"
            fill={color}
          />
          <path
            d="M8.36612 16.1697L7.34796 17.0022L5.99186 16.2088L6.36459 15.1253L8.36612 16.1697Z"
            fill={color}
          />
          <path
            d="M4.80005 14.558L3.8741 15.4264L2.47925 14.7203L2.69748 13.3516L4.80005 14.558Z"
            fill={color}
          />
        </>
      );
    case "b2b":
      return (
        <>
          <path
            d="M19.8055 18.0558V19.2503L20.6734 18.4295L24.4861 14.8234V17.8345L18.7255 23.2908L12.9725 17.8346L12.9713 14.825L16.777 18.4293L17.6451 19.2514V18.0558V4.88521H19.8055V18.0558ZM8.19497 9.9437V8.74919L7.32714 9.56999L3.51438 13.1761V10.165L9.27496 4.7087L15.0279 10.1648V13.1733L11.2235 9.57023L10.3554 8.7481V9.9437V23.1143H8.19497V9.9437Z"
            fill={color}
            stroke={color}
            strokeWidth="1.02875"
          />
        </>
      );
    case "power_cdm":
      return (
        <>
          <path
            d="M14.0617 16.0442L16.2739 14.1858L25 21M14.0617 16.0442L16.2739 21M14.0617 16.0442L9.76012 13.4425M25 21H16.2739M25 21L17.6259 9.84956H15.9047L14.0612 7L9.76012 13.4425M16.2739 21H3L8.5311 12.6991L9.76012 13.4425"
            stroke={color}
            strokeWidth="1.4"
          />
        </>
      );
    case "lwb":
      return (
        <>
          <path
            d="M18.8809 25C24.4306 21.8063 26.1237 19.8338 26.5 17.4149V9.18239L18.8809 6.77737V25Z"
            fill={color}
          />
          <path
            d="M18.8809 25C24.4306 21.8063 26.1237 19.8338 26.5 17.4149V9.18239L18.8809 6.77737M18.8809 25C16.5234 23.604 14.7917 22.4493 13.6135 21.3979L14.3998 19.1587C11.2868 20.4704 9.58999 19.9678 7.42655 18.0892C8.64708 18.0146 11.5059 17.6003 12.7881 15.9288C9.33615 15.9288 5.73342 15.6475 3.56998 12.3594C6.67405 13.0169 9.30779 13.5012 11.095 12.3594C6.14753 10.9506 1.49982 10.0112 1.5 4C6.26284 7.33814 10.5094 7.81063 12.9551 8.65601L18.8809 6.77737M18.8809 25V6.77737"
            stroke={color}
            strokeWidth="1.4"
            strokeMiterlimit="16"
          />
        </>
      );
    case "cb":
      return (
        <>
          <path
            d="M5 15.8426C5.58624 19.2347 7.81338 21.2559 14 25C20.5556 21.1443 22.5556 18.7629 23 15.8426V5.90355L14 3L5 5.90355V15.8426Z"
            stroke={color}
            strokeWidth="1.4"
          />
        </>
      );
    case "rwb":
      return (
        <>
          <path
            d="M9.11909 25C3.56938 21.8063 1.87625 19.8338 1.5 17.4149V9.18239L9.11909 6.77737V25Z"
            fill={color}
          />
          <path
            d="M9.11908 25C3.56938 21.8063 1.87625 19.8338 1.5 17.4149V9.18239L9.11908 6.77737M9.11908 25C11.4766 23.604 13.2083 22.4493 14.3865 21.3979L13.6002 19.1587C16.7132 20.4704 18.41 19.9678 20.5735 18.0892C19.3529 18.0146 16.4941 17.6003 15.2119 15.9288C18.6638 15.9288 22.2666 15.6475 24.43 12.3594C21.326 13.0169 18.6922 13.5012 16.905 12.3594C21.8525 10.9506 26.5002 10.0112 26.5 4C21.7372 7.33814 17.4906 7.81063 15.0449 8.65601L9.11908 6.77737M9.11908 25V6.77737"
            stroke={color}
            strokeWidth="1.4"
            strokeMiterlimit="16"
          />
        </>
      );
    case "lb":
      return (
        <>
          <path
            d="M14 25C20.5556 21.1443 22.5556 18.7629 23 15.8426V5.90355L14 3V25Z"
            fill={color}
          />
          <path
            d="M14 25C7.81338 21.2559 5.58624 19.2347 5 15.8426V5.90355L14 3M14 25C20.5556 21.1443 22.5556 18.7629 23 15.8426V5.90355L14 3M14 25V3"
            stroke={color}
            strokeWidth="1.4"
          />
        </>
      );
    case "rb":
      return (
        <>
          <path
            d="M14 25C7.44444 21.1443 5.44444 18.7629 5 15.8426V5.90355L14 3V25Z"
            fill={color}
          />
          <path
            d="M14 25C20.1866 21.2559 22.4138 19.2347 23 15.8426V5.90355L14 3M14 25C7.44444 21.1443 5.44444 18.7629 5 15.8426V5.90355L14 3M14 25V3"
            stroke={color}
            strokeWidth="1.4"
          />
        </>
      );
    default:
      return (
        <>
          <path
            d="M25 16V12H16L15.9998 3H11.9998V12H3V16H11.9998V25H15.9998L16 16H25Z"
            fill={color}
          />
        </>
      );
  }
};
